import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import ThemeRegistry from '@styles/ThemeRegistry.tsx';
import { Top5LinkEnhancer } from '@commerce-core/react-components';

createRoot(document.getElementById('root')!).render(
	<StrictMode>
		<Top5LinkEnhancer>
			<ThemeRegistry>
				<App />
			</ThemeRegistry>
		</Top5LinkEnhancer>
	</StrictMode>,
);
